import { Component, OnInit, viewChild, inject, ElementRef } from '@angular/core';
import { UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { Fields, Options } from 'src/app/shared/models/genmodel';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { UntypedFormControl } from '@angular/forms';
import {
  MatAutocompleteSelectedEvent,
  MatAutocomplete,
  MatAutocompleteTrigger,
  MatOption,
} from '@angular/material/autocomplete';
import { MatChipInputEvent, MatChipGrid, MatChipRow, MatChipRemove, MatChipInput } from '@angular/material/chips';
import { HttpClient } from '@angular/common/http';
import { GenModelService } from 'src/app/core/services/gen-model.service';
import { KeyValuePair } from 'src/app/shared/models/keyvaluepairModel';
import { MatFormField, MatInput, MatError } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'app-chipfullwidth',
  standalone: true,
  templateUrl: './chipfullwidth.component.html',
  styleUrls: ['./chipfullwidth.component.scss'],
  imports: [
    ReactiveFormsModule,
    MatFormField,
    MatChipGrid,
    MatChipRow,
    MatIcon,
    MatChipRemove,
    MatInput,
    MatAutocompleteTrigger,
    MatChipInput,
    MatAutocomplete,
    MatOption,
    MatTooltip,
    MatError,
  ],
})
export class ChipfullwidthComponent implements OnInit {
  private http = inject(HttpClient);
  private genModelService = inject(GenModelService);

  field: Fields;
  group: UntypedFormGroup;
  requiredBool: boolean;

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  chipCtrl = new UntypedFormControl();
  filteredChips: KeyValuePair[];
  chips: KeyValuePair[] = [];
  selectedChip = [];
  companyHiringTypeId = localStorage.getItem('companyHiringTypeId');

  readonly chipInput = viewChild<ElementRef<HTMLInputElement>>('chipInput');
  readonly matAutocomplete = viewChild<MatAutocomplete>('auto');

  constructor() {
    this.chipCtrl.valueChanges.subscribe((data: string) => {
      let urlValue = this.field.url;
      if (this.field.url.includes('{0}')) {
        urlValue = this.field.url.replace('{0}', this.companyHiringTypeId);
      }
      this._filter(data, urlValue);
    });
  }

  ngOnInit() {
    // console.log(this.group);
    // console.log(this.field.validations);
    // const data = this.field["value"];
    // console.log(data);

    this.genModelService.resetChipEvent.subscribe(() => {
      this.chips = [];
      this.selectedChip = [];
    });

    if (this.field.options && this.field.options.length > 0) {
      this.field.options.forEach((element) => {
        // console.log('here');
        this.chips.push(element);
        this.selectedChip.push(element.key);
      });
      this.group.get(this.field.name).setValue(this.selectedChip);
    }
    // console.log("this.chips", this.chips);
    else {
      this.chips = [];
    }
  }

  add(event: MatChipInputEvent): void {
    // Add Chips only when MatAutocomplete is not open
    // To make sure this does not conflict with OptionSelected Event
    if (!this.matAutocomplete().isOpen) {
      const input = event.input;
      const value = event.value;
      if (this.filteredChips) {
        const data = this.filteredChips.find((x) => x.value == value);

        //  data.selected = true;
        // Add our Chip
        if (data) {
          if ((value || '').trim()) {
            this.chips.push(data);
            // this.group[this.field.name].setValue(this.chips);
          }
        }

        // Reset the input value
        if (input) {
          input.value = '';
        }
      }
      this.chipCtrl.reset();
    }
  }

  addAutoComplete(event: MatChipInputEvent): void {
    if (!this.matAutocomplete().isOpen) {
      const inputProfile = event.input;
      // Reset the input value
      if (inputProfile) {
        inputProfile.value = '';
      }
      this.chipCtrl.setValue(null);
    } else {
      const input2Profile = event.input;
      if (input2Profile) {
        input2Profile.value = '';
      }
    }
  }

  remove(chip: Options): void {
    // console.log("chip -- ", chip)
    const index = this.chips.indexOf(chip);

    if (index >= 0) {
      this.chips.splice(index, 1);
      this.selectedChip.splice(index, 1);
    }
    // this.selectedChip.forEach((value, index) => {
    //   if (value === chip.key) {
    //     this.selectedChip.splice(index, 1)
    //   }
    // });
    // console.log(this.chips);
    // console.log(this.selectedChip);
    this.group.get(this.field.name).setValue(this.selectedChip);
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    const selectedVal = this.filteredChips.find((res) => res.value === event.option.value);
    let flag = true;
    if (this.selectedChip.length > 0) {
      for (const ckey of this.selectedChip) {
        if (ckey == selectedVal.key) {
          flag = false;
          break;
        }
      }
      if (flag) {
        this.selectedChip.push(selectedVal.key);
        this.group.get(this.field.name).setValue(this.selectedChip);
        // console.log("this.selectedChip", this.selectedChip);
        this.chips.push(selectedVal);
        // console.log("event.option", event.option);
        this.chipInput().nativeElement.value = '';
        this.chipCtrl.setValue(null);
        // console.log("chipCtrl---", this.chipCtrl)
      }
    } else {
      this.selectedChip.push(selectedVal.key);
      this.group.get(this.field.name).setValue(this.selectedChip);
      // console.log("this.selectedChip", this.selectedChip);
      this.chips.push(selectedVal);
      // console.log("event.option", event.option);
      this.chipInput().nativeElement.value = '';
      this.chipCtrl.setValue(null);
      // console.log("chipCtrl---", this.chipCtrl)
    }
    // this.selectedChip.push(selectedVal.key)
    // this.group.get(this.field.name).setValue(this.selectedChip);
    // console.log("this.selectedChip", this.selectedChip);
    // this.chips.push(event.option);
    // console.log("event.option", event.option);
    // this.chipInput.nativeElement.value = '';
    // this.chipCtrl.setValue(null);
    // console.log("chipCtrl---", this.chipCtrl)
  }

  // private _filter(value: string): string[] {
  //   const filterValue = value.toLowerCase();

  //   return this.f.filter(chips => chips.toLowerCase().indexOf(filterValue) === 0);
  // }

  private _filter(value, url) {
    if (value !== null && value !== '') {
      const filterValue = value.toLowerCase();
      if (this.field.url === null) {
        this.filteredChips = this.field.options.filter((option) => option.value.toLowerCase().includes(filterValue));
        this.group.get(this.field.name).setErrors({ error: true });
      } else {
        this.getFilterData(url, filterValue).subscribe((x) => {
          const temp = [];
          x.forEach((res, _key) => {
            temp.push({ key: res['skill_id'], value: res['skill_name'] });
          });
          this.filteredChips = temp;
        });
      }
    } else {
      this.filteredChips = [];
    }
  }
  getFilterData(url, value) {
    return this.http.get<KeyValuePair[]>(url + value);
  }

  // getFilterDataSkills(url, value) {
  //   // return this.http.get<KeyValuePair[]>(url + value);
  //   return this.http.get<KeyValuePair[]>("/assets/json/skillsOutput.json");
  // }
}
